import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import Casa from '../../../static/images/cash-advance/icono-main.svg'

const Container = styled.div`
  background: ${props => props.theme.colors.grisClaro};
  background:#eae9eb;
  position: relative;
  text-align: center;
  margin: 0 auto;

  h1 {
    font-size: 2.8em;
    margin: 0 0 0.3em;
    color: ${props => props.theme.colors.rojoBac};
  }

  h2 {
    font-size: 1.2em;
    font-weight: 400;
    color: ${props => props.theme.colors.grisOscuro};
    margin: 0 0 0.5em;
  }

  h3 {
    font-size: 24px;
    font-weight: 400;
  }

  p {
    color: ${props => props.theme.colors.grisOscuro};
    margin-bottom: 0 0 1.5em;
  }

  ${breakpoint('desktop')`
    h1{
      font-size: 3em;
    }

    h2{
      font-size: 2em;
    }

    a {
      font-size: 1.3em;
    }
  `}

  video {
    max-width: 100%;
  }
`

const Wrapper = styled.div`
  padding: 3em 2em;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;

  ${breakpoint('tablet')`
    display: flex;
    text-align: left;
    justify-content: center;

    & > div {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 100%;

      box-sizing: border-box;
    }

    & > div:first-of-type {
      padding-right: 20px;
    }
  `}
`

const H1 = styled.h1 `
    margin-top: -17px !important;
    font-weight: 600;
`

const ImageHipo = styled.img `
    width: 400px;
    margin: 25px auto;
    display: block;

    ${breakpoint('tablet')`
        margin: 10px auto;
        width: 550px;
    `}
        
`

const ContentButtons = styled.div `
    margin-top: -25px;
    ${breakpoint('tablet')`
        margin-top: 15px;
    `}  
`

const ButtonForm = styled.a `
  padding: 20px 0px;
  font-size: 24px;
  width: 100%;
  background: rgb(0,110,194);
  display: block;
  text-align: center;
  color: white;
  -webkit-text-decoration: none;
  text-decoration: none;
  font-weight: 600;
  margin: 9px auto;
  margin-top: 70px;

    ${breakpoint('tablet')`
        padding: 15px;  
        font-size: 18px;
        margin-top: 0px;
        margin-bottom: 60px;
        margin: 30px 0 70px 0px;
        width: 260px;
    `}
`

const Reverse = styled.div `
    width: 100%;

    & h1 {
        color: ${props => props.theme.colors.rojoBac};
        font-size: 40px;
    }

    ${breakpoint('tablet')`
        flex-direction: row-reverse;
        display: flex;
   `}

    ${breakpoint('desktop')`
        margin-bottom: -60px;
    `}
`

const Header = ({ formUrl, multicanalidad, pais }) => (
  <Container>
    <Wrapper>
        <Reverse>
        <div>
            <ImageHipo alt="Planillas" src={Casa}></ImageHipo>
        </div>
      <div style={{"width" : "100%"}}>
        <h1 style={{fontWeight: 600}}>Cash Advance</h1>
        <H1>BAC Credomatic</H1>
        <h3>Dinero inmediato desde</h3>
        <h3 style={{marginTop: -15}}>el sitio web de BAC Credomatic</h3>
        <ContentButtons><ButtonForm href="https://www.baccredomatic.com/">Ir a Banca en Línea</ButtonForm></ContentButtons>
      </div>
      </Reverse>
    </Wrapper>
  </Container>
);

export default Header